/** Bot replies are markdown; render them sanitized, with every link opening a new tab. */

import DOMPurify from "dompurify";
import { marked } from "marked";

export function renderMarkdown(target: HTMLElement, text: string): void {
  const html = marked.parse(text, { async: false });
  target.innerHTML = DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ["target", "rel"],
  });
  for (const link of target.querySelectorAll("a")) {
    link.target = "_blank";
    link.rel = "noopener noreferrer";
  }
}
